const DetailPage = () => import('@/views/scan-detail/detail-page/detail-page.vue')
export default [
  {
    path: '/ScanDetail/DetailPage',
    name: 'DetailPage',
    component: DetailPage,
    meta: {
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/DetailPage.js